import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getLocalStorageItem } from '../../../services/localStorageUtils';
import { classes, Root } from './utils';
import ROLES from '../../../constants/roles';
import { lightPalette } from '../../../theme';
import { PAGE_NOT_FOUND } from '../../../constants/staticContent';
import pageNotFound from '../../../assets/common-assets/404.png';

const PageNotFound = () => {
  const checkRole =
    getLocalStorageItem('role') === ROLES.SUPER_ADMIN
      ? '/dashboard'
      : ROLES.SALES_ADMIN
        ? 'sales-admin-dashboard'
        : '/';
  return (
    <Root className={classes.root}>
      <Box className={classes.pageNotFoundContainer}>
        <Box className={classes.pageNotFoundTextContainer}>
          <img
            src={pageNotFound}
            alt="page not found"
            className={classes.pageNotFoundLogo}
          />
        </Box>
        <Typography
          variant="h2"
          className={classes.pageNotFoundSubDescriptionText}
          color={lightPalette.deepMidnightBlue.main}
        >
          {' '}
          {PAGE_NOT_FOUND.MESSAGE}
        </Typography>
        <Typography
          variant="h5"
          className={classes.pageNotFoundDescriptionText}
        >
          {PAGE_NOT_FOUND.SUB_MESSAGE}
        </Typography>

        <Link to={checkRole} className={classes.backButtonLink}>
          <Button variant="contained" className={classes.backButton}>
            <Typography variant="body1">
              {PAGE_NOT_FOUND.BACK_TO_HOME}
            </Typography>
          </Button>
        </Link>
      </Box>
    </Root>
  );
};

export default PageNotFound;
